import type { TransphereIndicatorDto } from '../types/transphere/transphereIndicator';
import type { TransphereUnsentInvoicesDto } from '../types/transphere/transphereUnsentInvoices';

export interface TransphereIndicatorsSnapshot {
    unapplied: TransphereIndicatorDto | null;
    unsent: TransphereUnsentInvoicesDto | null;
}

// Each tenant's last banner answer, so a revisit renders from it and revalidates silently. Session-scoped.
const snapshots = new Map<string, TransphereIndicatorsSnapshot>();

export const readTransphereIndicators = (tenantCode: string): TransphereIndicatorsSnapshot | undefined =>
    snapshots.get(tenantCode);

export const cacheTransphereUnapplied = (tenantCode: string, unapplied: TransphereIndicatorDto | null): void => {
    snapshots.set(tenantCode, { unsent: null, ...snapshots.get(tenantCode), unapplied });
};

export const cacheTransphereUnsent = (tenantCode: string, unsent: TransphereUnsentInvoicesDto | null): void => {
    snapshots.set(tenantCode, { unapplied: null, ...snapshots.get(tenantCode), unsent });
};

export const clearTransphereIndicatorCache = (): void => snapshots.clear();
